import { LessonLike } from '@/helpers/types/LessonLike';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';

export const filterLessons = <T extends LessonLike>(lessons: T[], filters: LessonsFilter) => {
    const filteredLessons: T[] = [];

    for (const lesson of lessons) {
        const filteredSubLessons = lesson.sub_lessons ? filterLessons(lesson.sub_lessons as T[], filters) : [];

        const lessonTagIds = (lesson.tags || []).map((tag) => tag.id);
        const matchesTags = filters.tags.every((tag) => lessonTagIds.includes(tag.id));

        if (matchesTags || filteredSubLessons.length > 0) {
            lesson.sub_lessons = filteredSubLessons as typeof lesson.sub_lessons;
            filteredLessons.push(lesson);
        }
    }

    return filteredLessons;
};

export const filterLessonContainer = <
    T extends {
        lessons: LessonLike[];
    }
>(
    lessonContainers: T[],
    filters: LessonsFilter
) => {
    return lessonContainers
        .map((container) => {
            container.lessons = filterLessons(container.lessons, filters);
            return container;
        })
        .filter((pmSubPhase) => !!pmSubPhase && pmSubPhase.lessons.length > 0);
};
